import FaqAccordion from "../../components/sections/FaqAccordion";
import StitchFeaturePage from "../../components/sections/StitchFeaturePage";
import SectionLabel from "../../components/ui/SectionLabel";

const features = [
  { title: "Inbound", desc: "24/7 AI Voice Receptionist · Natural Language IVR · Customer Support Agent · Appointment Booking · Lead Qualification · Seamless Human Escalation" },
  { title: "Outbound", desc: "AI Cold Calling · Payment Reminder Calls · NPS Survey Calls · Re-engagement Campaigns · Appointment Reminders · Soft Collections" },
  { title: "Agent Assist (Human + AI)", desc: "Real-time transcription · AI-suggested responses · Auto call summary · CRM auto-update · Sentiment detection · Coaching insights" },
];

const useCases = [
  ["Real Estate", "Lead follow-up, site visit scheduling"],
  ["Healthcare", "Appointment booking, reminders"],
  ["Banking/Finance", "Payment reminders, loan inquiries"],
  ["E-Commerce", "Order tracking, re-engagement"],
  ["Legal", "Client intake, appointment booking"],
  ["Education", "Admission inquiries, fee reminders"],
  ["Insurance", "Policy renewals, claim status"],
];

const faqs = [
  { question: "Languages supported", answer: "Hindi, Tamil, Telugu, Marathi, Bengali, Kannada, and English." },
  { question: "What if AI can't handle a call?", answer: "It transfers to a human instantly with full context." },
  { question: "Setup time", answer: "Basic inbound: 2–3 weeks. Full setup: 4–6 weeks." },
  { question: "Data residency", answer: "India by default." },
];

const AiCallCentre = () => (
  <StitchFeaturePage
    label="SERVICE · AI CALL CENTRE"
    title="Your call centre,"
    titleAccent="never sleeps."
    subtitle="AI voice agents handling calls 24/7 — inbound support, outbound follow-up, appointment booking, and lead qualification in any language."
    features={features}
    badges={["ElevenLabs", "PlayHT", "Azure TTS", "Deepgram", "Twilio", "Plivo", "Exotel", "Knowlarity", "OpenAI GPT-4o", "Claude 3.5", "Vapi.ai", "Retell AI"]}
    ctaLabel="SET UP AI CALLING"
  >
    <div style={{ display: "grid", gap: 28 }}>
      <div style={{ background: "#0E0E0E", border: "1px solid rgba(212,168,67,0.18)", borderRadius: 4, padding: "28px clamp(20px, 4vw, 30px)" }}>
        <SectionLabel text="INDUSTRY USE CASES" />
        <div style={{ overflowX: "auto", marginTop: 20 }}>
          <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 560 }}>
            <thead>
              <tr>
                {["Industry", "Use Case"].map((heading) => (
                  <th key={heading} style={{ textAlign: "left", padding: "14px 0", borderBottom: "1px solid rgba(212,168,67,0.18)", fontFamily: "'Barlow Condensed', sans-serif", fontSize: 12, letterSpacing: "0.18em", color: "#D4A843", textTransform: "uppercase" }}>{heading}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {useCases.map((row) => (
                <tr key={row[0]}>
                  {row.map((cell) => (
                    <td key={cell} style={{ padding: "16px 0", borderBottom: "0.5px solid rgba(212,168,67,0.12)", fontFamily: "'DM Sans', sans-serif", fontSize: 14, color: "#F8F4EC" }}>{cell}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div>
        <SectionLabel text="FAQ" />
        <div style={{ marginTop: 20 }}>
          <FaqAccordion items={faqs} />
        </div>
      </div>
    </div>
  </StitchFeaturePage>
);

export default AiCallCentre;
